import { Box, Stack, Typography } from "@mui/material";
import SideBar from "../../components/sidebar";
import MainWrapper from "../../components/helpers/MainWrapper";
import SinkPhoto from "../../images/sink.jpg";
import Hand from "../../images/hand.webp";
import { useState } from "react";

const ProductEffect1 = () => {
  const [handDirection, setHandDirection] = useState<"none" | "right" | "left">(
    "none"
  );
  const [previousDirection, setPreviousDirection] = useState<"left" | "right">(
    "left"
  );
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <SideBar />
      <MainWrapper>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2.5rem",
          }}
        >
          <Typography
            variant="h2"
            fontSize={{ xs: "1.2rem", md: "1.8rem" }}
            maxWidth={{ xs: "90%", md: "100%" }}
            color="#33636E"
            fontWeight="bold"
          >
            تأثیر محصولات سارودی در پایداری زیست محیطی :
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "12px", md: "14px" },
              maxWidth: { xs: "90%", md: "100%" },
              color: "#2E2E2E",
              textAlign: "justify",
            }}
          >
            فلاش‌تاتک های سارودی دارای 2 حالت تخلیه آبِ قابل تنظیم می‌باشند، با
            فرض اینکه افراد یک خانوار 3 الی 4 نفری، به طور متوسط روزانه 12 بار
            از فلاش‌تانک سرویس‌بهداشتی استفاده می‌کنند: با استفاده از حالت 6
            لیتری (مَکس فلاش)، 72 لیتر آب مصرف خواهد شد، اما با استفاده از حالت
            2 لیتری (اکو فلاش)، این میزان به 24 لیتر کاهش می‌یابد و این یعنی، یک
            اختلاف بزرگ میان این 2 حالت وجود دارد! 48 لیتر آب اگر این اختلاف را
            در مقیاس حدود 25 میلیون خانوار ایران در نظر بگیریم، اختلاف کلی به 1
            میلیارد و 200 میلیون لیتر در روز می‌رسد. در یک سال، این اختلاف به
            عددی باورنکردنی 438 میلیارد لیتر آب می‌رسد که نشان دهنده تأثیر شگرفی
            در مصرف آب کل کشور است؛ این اختلاف باعث بوجود آمدن یک سوال می‌شود:
            آیا در هر بار استفاده از فلاش‌تانک، نیاز به انتخاب گزینه مَکس فلاش
            (6 لیتر خروج آب) وجود دارد؟!
          </Typography>

          <Box
            sx={{
              width: { xs: "92%", md: "100%" },
              display: "flex",
              alignItems: "center",
              paddingTop: { xs: "0rem", md: "2rem" },
              position: "relative",
            }}
          >
            <Box
              sx={{
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                gap: { xs: ".3rem", md: "2rem" },
                opacity: { lg: handDirection === "right" ? 1 : 0, sm: "1" },
                transition: "all .8s .1s",
              }}
            >
              <Typography
                color="#AA9889"
                fontSize={{ xs: ".8rem", md: "1.4rem" }}
              >
                2 لیتر مصرف آب
              </Typography>
              <Stack color="#2E2E2E">
                <Typography
                  fontSize={{ xs: ".8rem", md: "1.4rem" }}
                  whiteSpace="nowrap"
                >
                  6 لیتر در روز ( 3 بار استفاده در روز )
                </Typography>
                <Typography fontSize={{ xs: ".8rem", md: "1.4rem" }}>
                  180 لیتر در ماه
                </Typography>
              </Stack>
              <Typography
                fontSize={{ xs: ".8rem", md: "1.4rem" }}
                color="#33636E"
                fontWeight="bold"
              >
                2160 لیتر در سال
              </Typography>
            </Box>
            <Box
              sx={{
                width: { xs: "180px", lg: "500px", xl: "800px" },
                position: "relative",
              }}
            >
              <Box
                onMouseOver={() => setHandDirection("right")}
                onMouseOut={() => setHandDirection("right")}
                id="Right_Button"
                sx={{
                  cursor: "pointer",
                  height: "35%",
                  width: "22%",
                  position: "absolute",
                  top: "30%",
                  right: "22%",
                  borderRadius: "50%",
                  zIndex: "1000",
                }}
              />
              <Box
                onMouseOver={() => setHandDirection("left")}
                onMouseOut={() => setHandDirection("left")}
                id="Left_Button"
                sx={{
                  cursor: "pointer",
                  height: "45%",
                  width: "28%",
                  position: "absolute",
                  top: "20%",
                  left: "24%",
                  borderRadius: "50%",
                  zIndex: "1000",
                }}
              />
              <img src={SinkPhoto} width="100%" height="100%" alt="Sink" />
              <Box
                sx={{
                  position: "absolute",
                  transition: "all .8s",
                  right:
                    handDirection === "right"
                      ? "10%"
                      : handDirection === "left"
                      ? "50%"
                      : previousDirection === "left"
                      ? "10%"
                      : "50%",
                  top: "40%",
                  width: { xs: "0", lg: "120px", xl: "200px" },
                }}
              >
                <img src={Hand} alt="a hand." width="100%" height="100%" />
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: { xs: "left", sm: "right" },
                display: "flex",
                flexDirection: "column",
                gap: { xs: ".3rem", md: "2rem" },
                position: { xs: "absolute", md: "static" },
                top: { xs: "100%", sm: "10%" },
                left: { xs: "8%", sm: "20%" },
                opacity: { lg: handDirection === "left" ? 1 : 0, sm: "1" },
                transition: "all .8s .1s",
              }}
            >
              <Typography
                fontSize={{ xs: ".8rem", md: "1.4rem" }}
                color="#AA9889"
              >
                6 لیتر مصرف آب
              </Typography>
              <Stack color="#2E2E2E">
                <Typography
                  fontSize={{ xs: ".8rem", md: "1.4rem" }}
                  whiteSpace="nowrap"
                >
                  18 لیتر در روز ( 3 بار استفاده در روز )
                </Typography>
                <Typography fontSize={{ xs: ".8rem", md: "1.4rem" }}>
                  540 لیتر در ماه
                </Typography>
              </Stack>
              <Typography
                fontSize={{ xs: ".8rem", md: "1.4rem" }}
                color="#EB5528"
                fontWeight="bold"
              >
                6480 لیتر در سال
              </Typography>
            </Box>
          </Box>
        </Box>
      </MainWrapper>
    </Box>
  );
};

export default ProductEffect1;
